import { Grid } from "@mui/material";
import React from "react";
import Collection from "./Collection";
import Explore from "./Explore";
import "./home.css";
import CenterMode from "./ImageSlider";
import SectionThree from "./SectionThree";
import { Link } from "react-router-dom";

function Home() {
  return (
    <div className="Main_div">
      <Grid container justifyContent="center">
        <Grid item xs={11} md={10} lg={10}>
          {/* NESTED GRID FOR HOME PAGE CONTENT */}
          <Grid
            container
            alignItems="center"
            sx={{
              justifyContent: {
                xs: "center",
                sm: "center",
                md: "space-between",
              },
            }}
          >
            <Grid item xs={11} sm={10} md={6} lg={6}>
              <div className="hero_cover">
                <h1 className="hero_head">
                  Discover, Collect,
                  <br /> And
                  <span className="hero_span"> Sell Extraordinary NFTs </span>
                </h1>
                <p className="hero_para">
                  Lorem ipsum dolor sit amet, consectetur adipiscing
                  elit.Praesent facilisis ipsum vitae lectus consequat
                  sollicitudin.
                </p>
                <div className="hero_btn_con">
                  <button className="common_btn"> View Market </button>

                  <Link to="/create">
                    {" "}
                    <button className="hero_btn"> Upload </button>
                  </Link>
                </div>
              </div>
            </Grid>
            <Grid item xs={12} sm={10} md={4.5} lg={4.5}>
              {/* NESTED GRID FOR HOME CARD GRID */}
              <Grid container justifyContent="space-around" alignItems="center">
                <Grid item xs={12} sm={11} md={9} lg={9}>
                  <div className="home_card">
                    <img
                      src="./Assets/home_card.png"
                      alt="home card"
                      className="img_width"
                    />
                    <div className="home_card_content">
                      <div className="h_card_time">
                        <h5 className="card_subtitles">20h : 30m ; 58s</h5>
                        <h6 className="h_card_title">Remaining Time</h6>
                      </div>
                      <div className="h_card_time">
                        <h5 className="card_subtitles">19.4 ETH</h5>
                        <h6 className="h_card_title">Highest Bid</h6>
                      </div>
                    </div>
                  </div>
                </Grid>
                <Grid item md={2} lg={2}>
                  <div className="home_side_card">
                    <h5 className="card_side_1">12.5k</h5>
                    <p className="card_side_p">Art Work</p>
                  </div>
                  <div className="home_side_card">
                    <h5 className="card_side_1">1.7M+</h5>
                    <p className="card_side_p">Artists</p>
                  </div>
                  <div className="home_side_card">
                    <h5 className="card_side_1">45k</h5>
                    <p className="card_side_p">Auctions</p>
                  </div>
                </Grid>
              </Grid>
              {/* NESTED GRID FOR HOME CARD GRID */}
            </Grid>
          </Grid>
          {/* NESTED GRID FOR HOME PAGE CONTENT */}
        </Grid>
      </Grid>
      <div className="section_space"></div>
      {/* IMAGE SLIDER */}
      <Grid container justifyContent="flex-end">
        <Grid item xs={11} lg={11}>
          <CenterMode />
        </Grid>
      </Grid>

      {/* IMAGE SLIDER */}
      <div className="section_space"></div>

      {/* third section */}
      <SectionThree />
      {/* third section */}

      {/* EXPLORE SECTION */}
      <Explore />
      {/* EXPLORE SECTION */}
      {/* Collection section */}
      <Collection />
      {/* Collection section */}
    </div>
  );
}

export default Home;
